// extracted by mini-css-extract-plugin
export default {"brand-tile":"BrandTile_brand-tile__cWF8a","brand-image":"BrandTile_brand-image__afHDf","brand-name":"BrandTile_brand-name__ZvrbF"};